/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Box_Label_Freight_CollectInputs */

const vi_box_label_freight_collect = /** @type {(inputs: Box_Label_Freight_CollectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thu cước`)
};

/**

* @param {Box_Label_Freight_CollectInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const box_label_freight_collect = /** @type {((inputs?: Box_Label_Freight_CollectInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Box_Label_Freight_CollectInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_box_label_freight_collect(inputs)
});